import React, { Component } from 'react';
// import { connect } from "react-redux";
// import PropTypes from 'prop-types';
// import { withStyles } from '@material-ui/core/styles';
//import { withRouter } from "react-router-dom";
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from "@material-ui/core/Typography";
import {
  WarningIcon,
  SuccessIcon,
} from "../bundles/IconsBundle";
// import {
//   SetPropertyValue,
//   SaveData,
// } from "../actions/TaskActions";
//import { setTimeout, clearTimeout } from 'timers';
import ConfirmSelectedPositionDialog from './dialogs/ConfirmSelectedPositionDialog';
import { Text } from '../extensions/LangaugeContainer';

const styles = {
  mainwrap: {
    marginTop: '0px',
    overflowY: 'hidden'
  },
  item: {
    fontSize: '16px',
    color: '#ffffff',
    padding: '10px',
    background: '#00B0DE',
    marginBottom: '5px',
  },
  itemwrap: {
    height: '360px',
    padding: '0px',
    background: '#B2EBF2',
  },
  mainitem: {
    padding: "0px",
  },
  stueck: {
    color: '#00B0DE',
    display: "block",
    fontSize: "16px"
  },
  image: {
    width: '90%',
    height: 'auto',
    margin: '10px 5% 10px 5%'
  }
};
export default class StepThree extends Component {
  state = {
    questionDialogOpen: false,
    selectedItems: []

  }

  handleCloseDialogs = () => {
    this.setState({
      ...this.state,
      questionDialogOpen: false
    });
  };

  handleLongPress = (val) => {
    if(!this.props.disabled) this.longPressTimer = setTimeout(() => this.saveData(val), 500);
  }

  handlePressRelease = () => {
    clearTimeout(this.longPressTimer);
  }

  saveData = async (val) => {
    const data = this.props.app.Positions;
    let selected = 3;
    //console.log("data:", data);
    if (data && data.length > 0) {
      let pozicije = await data.map(row => {
        if (row.Position === val.Position) {
          row.Selected = row.Selected === 0 ? 1 : 0;
          return row;
        } else {
          return row;
        }
      });
      //console.log("Editovane pozicije", pozicije);
      if (pozicije.length > 0) {
        selected = pozicije.filter(e => e.Selected === 0).length > 0 ? 4 : 3;
      }
      await this.props.SaveData(this.props.app, { Positions: pozicije, Geliefert: selected })
      await this.props.SetPropertyValue(this.props.app, "Positions", pozicije);
    //  await this.props.SetPropertyValue(this.props.app, "Geliefert", selected);
    } else {
      //console.log("saved new");
      let pozicije = await this.props.position.map(row => {
        if (row.Position === val.Position) {
          return {
            Selected: row.Selected === 0 ? 1 : 0,
            Position: row.Position
          }
        }
        else {
          return {
            Selected: row.Selected,
            Position: row.Position
          }
        }
      });

      await this.props.SaveData(this.props.app, { Positions: pozicije, Geliefert: 4 });
      await this.props.SetPropertyValue(this.props.app, "Positions", pozicije);
    //  await this.props.SetPropertyValue(this.props.app, "Geliefert", 4); // Deselekcija pozicije kada nema prethodnih promjena na pozicijama / oznaka za auftrag Teilweise

    }
  }

  // selectItem = (val) => {
  //   let selectedItemsData = this.state.selectedItems;
  //   let selectedItemIndex = selectedItemsData.findIndex(function(f){return f.id === val.id})
  //   if(selectedItemIndex !== -1){
  //     selectedItemsData.splice(selectedItemIndex,1);
  //   }else{
  //     selectedItemsData.push(val);
  //   }

  //   this.

  // }

  // confirmSelected = () => {
  //   alert("ovde proslijediti event");
  //   this.handleCloseDialogs();
  //   //u staroj aplikaciji nije bilo confirmationa
  // }

  // confirmDialogOpen = () => {
  //   this.setState({ ...this.state, questionDialogOpen: true });
  // }

  render() {
    //console.log("Positionen props: ", this.props);
    //console.log("EnteredData:", this.props.enteredData);
    return (
      <div>
        {this.props.position.length === 0 && (
          <div style={{ lineHeight: "24px", marginTop: "5px" }}>
            <Typography component="p" >
              <span style={{ verticalAlign: "middle", display: "inline-block", height: "24px" }}><WarningIcon /></span>
              <span><Text tid="positionNotFound"/></span>
            </Typography>
          </div>
        )}
        <Grid container spacing={8} direction="row" justify="flex-start" alignItems="flex-start">
          {this.props.position.map(val => (
            <Grid item xs={3} key={val.id}>
              <Paper style={styles.itemwrap}
                onTouchStart={() => this.handleLongPress(val)}
                onTouchEnd={this.handlePressRelease}
                onMouseDown={() => this.handleLongPress(val)}
                onMouseUp={this.handlePressRelease}
                onMouseLeave={this.handlePressRelease}
              >
                <div style={styles.mainitem}>
                  <div style={styles.item}>
                    <div>
                    <Text tid="position"/>: {val.Position}
                    </div>
                    {val.Selected === 1 && (
                      <div>
                        <Typography component="p" >
                          <span style={{ verticalAlign: "middle", display: "inline-block", height: "24px" }}><SuccessIcon style={{ color: '#FFFFFF' }} /></span>
                        </Typography>
                      </div>
                    )}
                  </div>
                  <span style={styles.stueck}><Text tid="piece"/>: <span style={{ color: "#666666" }}>{val.StueckFertig + " / " + val.Stueck}</span></span>
                  <span style={styles.stueck}><Text tid="width"/>: <span style={{ color: "#666666" }}>{val.Breite}</span></span>
                  <span style={styles.stueck}><Text tid="height"/>: <span style={{ color: "#666666" }}>{val.Hoehe}</span></span>
                  {val.Bild !== null && val.Bild !== "" && (
                    <span>
                      <img alt="Embedded" src={"data:image/png;base64," + val.Bild} style={styles.image} />
                    </span>
                  )}
                  {(val.Bild === null || val.Bild === "") && (
                    <span style={styles.stueck}>{val.Positionstext}</span>
                  )}
                </div>
              </Paper>
            </Grid>
          ))}

          {/* <Grid item xs={3}>
          <Paper style={styles.itemwrap}
            onTouchStart={this.handleLongPress}
                   onTouchEnd={this.handlePressRelease}
                   onMouseDown={this.handleLongPress}
                   onMouseUp={this.handlePressRelease}
                   onMouseLeave={this.handlePressRelease}>
            <div style={styles.mainitem}>
              <div style={styles.item}>
                Position: 1
              </div>
              <span style={styles.stueck}>Stueck: <span style={{ color: "#666666" }}>1/1</span></span>
              <span style={styles.stueck}>Breite: <span style={{ color: "#666666" }}>850</span></span>
              <span style={styles.stueck}>Hoehe: <span style={{ color: "#666666" }}>100</span></span>
            </div>
          </Paper>
        </Grid>
        <Grid item xs={3}>
          <Paper style={styles.itemwrap}>
            <div style={styles.mainitem}>
              <div style={styles.item}>
                Position: 1
              </div>
              <span style={styles.stueck}>Stueck: <span style={{ color: "#666666" }}>1/1</span></span>
              <span style={styles.stueck}>Breite: <span style={{ color: "#666666" }}>850</span></span>
              <span style={styles.stueck}>Hoehe: <span style={{ color: "#666666" }}>100</span></span>
            </div>
          </Paper>
        </Grid>
        <Grid item xs={3}>
          <Paper style={styles.itemwrap}>
            <div style={styles.mainitem}>
              <div style={styles.item}>
                Position: 1
              </div>
              <span style={styles.stueck}>Stueck: <span style={{ color: "#666666" }}>1/1</span></span>
              <span style={styles.stueck}>Breite: <span style={{ color: "#666666" }}>850</span></span>
              <span style={styles.stueck}>Hoehe: <span style={{ color: "#666666" }}>100</span></span>
            </div>
          </Paper>
        </Grid> */}
        </Grid>
        <ConfirmSelectedPositionDialog
          open={this.state.questionDialogOpen}
          handleClose={this.handleCloseDialogs}
          confirmSelected={this.confirmSelected}
        />
      </div>
    );
  }
}


